<div class="flex justify-between items-center content-center">
  <h1 mat-dialog-title class="mat-dialog-title text-2xl">Add Room</h1>
  <button mat-icon-button [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <app-room-form [form]="roomForm"></app-room-form>
  <app-progress-button
    color="accent"
    text="Save"
    (submit)="onSave()"
    [disabled]="!roomForm.valid"
    [submitting]="submitting"
  >
  </app-progress-button>
</mat-dialog-content>
